/**
 * ============================================================================
 * MASTER SERVICE: Login Audit Logs Service (`tbl_login_logs` - Sheet 15)
 * ============================================================================
 * Purpose:
 *   Handles API requests for security audit logs, login failure analysis,
 *   IP tracking, and login statistic breakdowns.
 *
 * Database Scope:
 *   Master Database (`digimaster`)
 * ============================================================================
 */

import api from "../../core/services/api";
import { createCrudService } from "../../core/services/crudServiceFactory";

const baseLoginLogService = createCrudService("login-logs");

const loginLogService = {
  ...baseLoginLogService,

  /**
   * Retrieves summary analytics (total attempts, successful, failed, locked out).
   *
   * @returns {Promise<Object>} Statistics payload
   */
  getStats: () => {
    return api.get("/login-logs/stats");
  },
};

export default loginLogService;
